import { BaseModel } from '../base/base-model'

/**
 * @memberOf loavies.models.wallet
 * @constructor
 */
export class WalletModel extends BaseModel {
  /**
   * @param {number} balance
   * @param {number} reserved
   * @param {number} bonus
   * @param {string} currency
   * @param {boolean} payoutEnabled
   * @param {string} iban
   * @param {string} obfuscatedIban
   */
  constructor({
    balance,
    reserved,
    bonus,
    currency,
    payoutEnabled,
    iban,
    obfuscatedIban,
  }) {
    super()

    /** @type {number} */
    this.balance = balance

    /** @type {number} */
    this.reserved = reserved

    /** @type {number} */
    this.bonus = bonus

    /** @type {number} */
    this.total = balance + bonus

    /** @type {string} */
    this.currency = currency

    /** @type {boolean} */
    this.payoutEnabled = payoutEnabled

    /** @type {string} */
    this.iban = iban

    /** @type {string} */
    this.obfuscatedIban = obfuscatedIban
  }
}

export const WALLET_STATES = {
  SETUP: 'SETUP',
  LEGAL_ENTITY: 'LEGAL_ENTITY',
  TRANSFER_INSTRUMENT: 'TRANSFER_INSTRUMENT',
  ACCOUNT_HOLDER: 'ACCOUNT_HOLDER',
  COMPLETE: 'COMPLETE',
}
